function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "background"), React.createElement("rect", {
  fill: "none",
  id: "canvas_background",
  height: 31,
  width: 29,
  y: -1,
  x: -1
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "Layer 1"), React.createElement("path", {
  id: "svg_1",
  d: "m14.29766,7.943614c-0.287,-0.082 -0.582,-0.139 -0.895,-0.139c-1.813,0 -3.279,1.468 -3.279,3.279c0,1.813 1.467,3.281 3.279,3.281s3.279,-1.468 3.279,-3.281c0,-0.312 -0.057,-0.607 -0.139,-0.894c-0.262,0.61 -0.867,1.038 -1.572,1.038c-0.945,0 -1.713,-0.767 -1.713,-1.712c0,-0.705 0.428,-1.31 1.04,-1.572z"
}), React.createElement("path", {
  id: "svg_2",
  d: "m21.55066,20.179614c-2.164,1.941 -5.014,3.131 -8.148,3.131s-5.984,-1.189 -8.148,-3.131c-2.732,2.229 -5.947,5.375 -4.799,7.1c1.906,2.859 3.42,-1.27 12.947,-1.27s11.041,4.129 12.947,1.27c1.149,-1.725 -2.066,-4.871 -4.799,-7.1z"
}), React.createElement("path", {
  id: "svg_3",
  d: "m7.84566,11.084614c0,-3.068 2.488,-5.557 5.557,-5.557s5.557,2.488 5.557,5.557c0,0.126 -0.01,0.25 -0.02,0.373c1.109,-0.053 3.109,-0.295 5.215,-1.246c-0.445,-5.553 -5.084,-9.924 -10.752,-9.924s-10.307,4.371 -10.752,9.925c2.105,0.951 4.105,1.193 5.215,1.246c-0.01,-0.124 -0.02,-0.247 -0.02,-0.374z"
}), React.createElement("path", {
  id: "svg_4",
  d: "m13.40266,21.880614c5.834,0 10.576,-4.631 10.777,-10.416c-2.266,0.938 -4.355,1.128 -5.439,1.152c-0.666,2.322 -2.801,4.023 -5.338,4.023s-4.672,-1.701 -5.338,-4.023c-1.084,-0.024 -3.174,-0.215 -5.439,-1.152c0.201,5.785 4.943,10.416 10.777,10.416z"
}), React.createElement("text", {
  id: "svg_5",
  fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif",
  fontWeight: "bold",
  fontSize: "5px",
  fill: "#000000",
  y: 48,
  x: 0
}, "Created by TKBT001"), React.createElement("text", {
  id: "svg_6",
  fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif",
  fontWeight: "bold",
  fontSize: "5px",
  fill: "#000000",
  y: 53,
  x: 0
}, "from the Noun Project"));

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 29,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera.13b3a090.svg";
export { ForwardRef as ReactComponent };